import type { ReactNode } from 'react';
import { cx } from '@/cva.config';

interface KbdProps {
  children: ReactNode;
  className?: string;
}

export const KeyboardShortcutKey = ({ children, className }: KbdProps) => (
  <div
    className={cx(
      'inline-flex min-w-4.5 items-center justify-center rounded-sm border border-b-2 border-border bg-surface px-1.5 py-px font-mono text-xs/3.5 font-medium text-foreground-muted',
      className,
    )}
  >
    <span>{children}</span>
  </div>
);
